import api, { APIClient } from "../api";
import { SharePointSiteUsageDetail, SharePointSiteUsageStorage } from "./SharePointSiteUsageStorage";
export class SaasService extends APIClient {

    constructor(props: any) {
        super(props);
        this.endpoint = this.endpoint;
    }

    async GetCards(month: string, year: string) {
        const url = this.endpoint + `/api/Saas/GetProductSlaTotalSolicitation?month=${month}&year=${year}`;
        return api({
            method: 'get',
            url,

        });
    }
    async GetUsersChart(days: number) {
        const url = this.endpoint + `/api/Saas/GetOffice365ActiveUserCountsClientGroupDays?days=${days}`;
        return api({
            method: 'get',
            url,

        });
    }

    async RetrieveUserLicenses() {
        const url = this.endpoint + `/api/Saas/RetrieveUserLicenses`;
        return api({
            method: 'get',
            url,

        });
    }
    async GetActivationChart() {
        const url = this.endpoint + `/api/Saas/GetOffice365ActivationCounts`;
        return api({
            method: 'get',
            url,

        });
    }
    async GetEmailActivityChart(days: number) {
        const url = this.endpoint + `/api/Saas/GetGraphOffice365EmailActivityCount?days=${days}`;
        return api({
            method: 'get',
            url,

        });
    }
    async GetEmailUsageChart(days: number) {
        const url = this.endpoint + `/api/Saas/GetMailBoxUsageMailBoxCounts?days=${days}`;
        return api({
            method: 'get',
            url,

        });
    }
    async GetOneDriveUsageChart(days: number) {
        const url = this.endpoint + `/api/Saas/GetGraphOffice365OneDriveUsageAccountCounts?days=${days}`;
        return api({
            method: 'get',
            url,

        });
    }
    async GetOffice365EmailActivityUserDetail(days: number) {
        const url = this.endpoint + `/api/Saas/GetOffice365EmailActivityUserDetail?days=${days}`;
        return api({
            method: 'get',
            url,

        });
    }

    async GetMailBoxUsageMailBoxUsage(days: number) {
        const url = this.endpoint + `/api/Saas/GetMailBoxUsageMailBoxUsage?days=${days}`;
        return api({
            method: 'get',
            url,

        });
    }

    async GetSharePointSiteUsageDetail(days: number): Promise<SharePointSiteUsageDetail[]> {
        try {
            const url = this.endpoint + `/api/Saas/GetSharePointSiteUsageStorage?days=${days}`;
            return (await api({
                method: 'get',
                url,
            })).data;
        } catch (e) {
            console.error(e);
        }
        return [] as unknown as SharePointSiteUsageDetail[];
    }

    async GetOneDriveUsageAccountReport(days: number) {
        const url = this.endpoint + `/api/Saas/GetOneDriveUsageAccountReport?days=${days}`;
        return api({
            method: 'get',
            url,

        });
    }

    async GetUserCount() {
        const url = this.endpoint + `/api/Saas/GetGraphOffice365ActivationsUserCounts`;
        return api({
            method: 'get',
            url,

        });
    }

    async GetAWSDashboardEmbedUrl(dashid: string) {
        const url = this.endpoint + `/api/Saas/GetAWSDashboardEmbedUrl?dashid=${dashid}&refresh=${Math.random()}`;
        return api({
            method: 'get',
            url
        });
    }

    async GetbyClientGroupIdAndTileId(tileId: string) {
        const url = this.endpoint + `/api/Saas/GetbyClientGroupIdAndTileId?tileId=${tileId}&refresh=${Math.random()}`;
        return api({
            method: 'get',
            url
        });
    }



}